import React, {Component} from 'react';
import { connect } from "react-redux"
import Form from '../Components/Form';
import { apiUrl, entryPointValue, host } from '../config';
import { resetSubmissionResult, resetSubmissionStatus, setSubmissionResult, setSubmissionStatus } from '../actions/sweepstakes';
import { getJsonDataFromStorage, hasSubmittedToday, setJsonDataToStorage, setSubmissionDatetimeToStorage } from '../utils/functions';

class FormContainer extends Component{

  constructor(props) {
    super(props);

    this.defaultStatus = 0;
    this.entryPointValue = entryPointValue;
    this.apiUrl = apiUrl;

    this.state = {
      status: this.defaultStatus,
      result: null,
      data: {}
    }

    this.formSubmit = this.formSubmit.bind(this);
  }

  formSubmit(jsonData) {

    const json = Object.assign({}, jsonData);
    this.props.formSubmitCallback && this.props.formSubmitCallback(json);

    if (json.phoneNumber && json.agreeText) {
      json['mobileNumber'] = json.phoneNumber;
      json['entryPoint'] = this.entryPointValue;
      fetch(host + this.apiUrl + '/text-subscribe', {
        method: 'POST',
        body: JSON.stringify(json)
      })
      .then(resp=>resp.json)
      .then(data=>console.log('st:',data));
    }

    fetch(host + this.apiUrl + '/save-entry', {
      method: 'POST',
      body: JSON.stringify(json),
    })
    .then((response) => {
      this.setState({status: response.status});

      return response.json();
    })
    .then((result) => {
      console.log('fetch results:', result);

      this.setState({
        result, 
        data: json, 
      });

    })
    .catch((error) => {
      this.setState({result: error, data:json});
    });

  }

  setDataFromStorage() {

    const data = getJsonDataFromStorage() || this.state.data;
    this.setState({data});
  }

  isSameDaySubmission() {

    return hasSubmittedToday();
  }

  componentDidMount() {

    this.setDataFromStorage();
  }

  componentDidUpdate(prevProps, prevState) {
    
    const {
      result,
      status,
      data
    } = this.state,
    hasResult = result !== null,
    serverResponseDone = hasResult && prevState.result !== result,
    storageRetrivalDone = !hasResult && data !== {} && prevState.data !== data;
    
    //response retrieved from server after submit
    if (serverResponseDone) {
      const clonedResults = Object.assign({},result),
        clonedData = Object.assign({}, data, {entriesCount: result.entriesCount});

      setSubmissionDatetimeToStorage(result.datetime);
      
      this.props.setSubmissionResult(result);
      this.props.setSubmissionStatus(status);

      //store submission date along with form data in local storage
      setJsonDataToStorage(clonedData);
    }
    
    if (prevProps.submissionStatus !== this.props.submissionStatus) {
      this.props.formResultsCallback && this.props.formResultsCallback(status, result);
    }

    if (storageRetrivalDone) {
      this.props.storageRetrivalDoneCallback && this.props.storageRetrivalDoneCallback(data);
      this.isSameDaySubmission() && this.props.isSameDaySubmissionCallback && this.props.isSameDaySubmissionCallback();
    }
  }

  render() {
    
    const {
      data,
      error,
    } = this.state;

    return <Form
      handleSubmit={this.formSubmit}
      submitError={error}
      data={data}
      />;
  }
}

const mapStateToProps = state => ({
  submissionResult: state.sweepstakes.submissionResult,
  submissionStatus: state.sweepstakes.submissionStatus
});

const mapDispatchToProps = dispatch => ({
	setSubmissionResult: data=> {
		dispatch(setSubmissionResult(data));
	},
	resetSubmissionResult: data=> {
		dispatch(resetSubmissionResult(data));
	},
	setSubmissionStatus: data=> {
		dispatch(setSubmissionStatus(data));
	},
	resetSubmissionStatus: data=> {
		dispatch(resetSubmissionStatus(data));
	}
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormContainer)